<template>
	<div id="footer" class="container-fluid" style="position: relative;">
		<div class="container hidden-xs">
			<div class="logo">
				<img src="@/assets/img/logo_white.png" alt="logo图">
			</div>
			<div class="row" style="padding-bottom: 30px;">
				<div class="col-md-8" style="margin-top: 30px; margin-bottom: 80px;">
					<div class="col-md-3" v-for="(item, index) in navList" :key="item.id">
						<div style="color: #363636; text-align: left; font-size: 18px; font-weight: 600;">
							<router-link :to="item.url">
							{{item.name}}
							</router-link>
						</div>
						<div style="color: #363636; text-align: left; font-size: 14px; margin-top: 20px;" v-for="(child, childIndex) in item.children" 
							:key="child.id">
							<router-link :to="item.url">
								{{child.name}}
							</router-link>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div style="font-weight: 600; color: #000; text-align: left;">{{getConstant('CONTACT_US')}}：</div>
					<div style="color: #5494d2; font-size: 30px; font-weight: 600; text-align: left; padding-left: 10px; margin-top: 8px;">+852 9685 1999</div>
					<div style="position: relative; cursor: pointer;">
						<img src="@/assets/img/footer-link.png" style="margin-top: 30px; width: 250px;" />
						<div style="position: absolute; top: 0; left: 0; width: 250px; height: 100%; display: flex;">
							<div style="width: 25%;" @click="open('https://www.youtube.com/channel/UCuVtCLzdeygQIOQALv9oEhQ')"></div>
							<div style="width: 25%;" @click="open('https://wa.link/extmab')"></div>
							<div style="width: 25%;" @click="open('https://www.instagram.com/kinlyhk/')"></div>
							<div style="width: 25%;" @click="open('https://www.facebook.com/kinlyhongkong/')"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="visible-xs" style="width: 100vw;">
			<div class="img-list">
				<div>
					<img src="@/assets/img/m-footer-1.png" style="width: 35vw;" />
				</div>
				<div @click="open('https://www.youtube.com/channel/UCuVtCLzdeygQIOQALv9oEhQ')">
					<img src="@/assets/img/m-footer-5.png" style="width: 30px;" />
				</div>
				<div @click="open('https://wa.link/extmab')">
					<img src="@/assets/img/m-footer-2.png" style="width: 30px;" />
				</div>
				<div @click="open('https://www.instagram.com/kinlyhk/')">
					<img src="@/assets/img/m-footer-3.png" style="width: 30px;" />
				</div>
				<div @click="open('https://www.facebook.com/kinlyhongkong/')">
					<img src="@/assets/img/m-footer-4.png" style="width: 30px;" />
				</div>
			</div>
		</div>
		
		<div class="hidden-xs" style="position: absolute; right: 0; top: 0; width: 80px; height: 100%;">
			<img src="@/assets/img/goTop.png" style="width: 100%; height: 100%;" @click="GoTop()" />
		</div>
	</div>
</template>
<script>
	import { getConstant, getChannelList } from '@/api/api';
	export default {
		name: "Footer",
		data() {
			return {
				navList: []
			};
		},
		created() {
			let that = this;
			getChannelList({type: 1}, function(list) {
				for(let i in list) {
					list[i].children = list[i].children || [];
				}
				that.navList = list;
			});
		},
		methods: {
			getConstant,
			GoTop() {
				(function smoothscroll() {
					var currentScroll =
						document.documentElement.scrollTop || document.body.scrollTop;
					if (currentScroll > 0) {
						window.requestAnimationFrame(smoothscroll);
						window.scrollTo(0, currentScroll - currentScroll / 10);
					}
				})();
			},
			open: function(url) {
				window.open(url);
			}
		}
	};
</script>
<style scoped>
	#footer {
		width: 100%;
		height: 100%;
		color: #fff;
		background: #f4f4f4;
		overflow: hidden;
		text-align: center;
	}

	.logo {
		height: 45px;
		margin: 80px auto 20px;
	}
	
	@media screen and (max-width: 997px) {
		#footer {
			width: 100%;
			height: 100%;
			color: #fff;
			background: #4E96D1;
			overflow: hidden;
			height: 100px;
			display: flex;
			align-items: center;
			position: fixed;
			left: 0;
			bottom: 0;
			z-index: 99;
		}
		
		#footer .img-list {
			display: flex;
			justify-content: space-around;
			align-items: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue